// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PredictionModel.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedExpression component
 */
import React from 'react';
import { observer } from 'mobx-react';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import Label from 'share/components/controls/Izenda.Label';
import DropDown from 'share/components/controls/Izenda.DropDown';


@observer
class PredictedModel extends React.Component {
  componentWillMount() {

  }
  self = this
  componentDidMount() {
    // To be replaced by the below code
  //  this.props.store.fetchFromFetcher(this.props.querySourceId);
  //  let tempId = {
  //  tempQueryId: '659f4f75-79cf-4ea2-981d-672f9739274c',
  //    ashoo: '2893f402-ef73-41bc-bb2f-5e5450872bb2',
  //    randip:'market'
  //  };
    this.props.store.fetchFromFetcher(this.props.querySourceId).then((data)=>{
        this.props.store.PreditectedDetailList = JSON.parse(data);
        if ( this.props.store.PreditectedDetailList.success !== false){
        let modelList =  this.props.store.PreditectedDetailList.Models;
        let modelFeatures = modelList.filter(v => v.modelName === this.props.store.clonedModel.selectedModel)[0];
        this.props.store.clonedModel.inputFeatures = modelFeatures !== undefined ? modelFeatures.features : [];
        this.props.store.clonedModel.accuracy = modelFeatures!== undefined ? modelFeatures.accuracy : '';
        this.props.store.clonedModel.percentError = modelFeatures!== undefined ? modelFeatures.percentError : '';
      }
      });
  }
  static displayName = 'Models';


  componentDidUpdate() {

   }
  /**
   * Handel on expression's blur event.
   * @param {Object} e
   */
  blurExpression = (e: Object) => {
    !this.props.expressionSelectionUI.visible &&
      this.props.validateExpression();
  };
onChangeFormat = (selectedItem) => {

 var selectedModelData = this.props.store.PreditectedDetailList.Models.
 filter(v => v.modelName === selectedItem.label)[0];
 this.props.store.clonedModel.selectedModel = selectedModelData.modelName;
 this.props.store.clonedModel.inputFeatures = selectedModelData.features;
 this.props.store.clonedModel.selectedModelType = selectedModelData.modelType;
 this.props.store.clonedModel.targetValue = selectedModelData.target;
 this.props.store.clonedModel.accuracy = selectedModelData.accuracy;
 this.props.store.clonedModel.relationColumn = selectedModelData.relationColumn;
 this.props.store.clonedModel.percentError = selectedModelData.percentError;
}

  render() {
    let {
      localization
    } = this.props;
    var a = [];

    if (this.props.store.PreditectedDetailList.Models != undefined) {
      this.props.store.PreditectedDetailList.Models.map((x) => {
        let a1 = {};
          a1.Id = x.modelName,
          a1.value = x.modelName;
        a.push(a1);
      });
    }

    return (
      <FormGroup className='u_paddingRight addPredictionFields'>
        <div className='fieldsWrap'>
          <div className='labelWrap'>
            <Label className='text-left  validation required'>
              {localization.getText('COMMON_LABEL_MODEL')}
            </Label>
          </div>
          <div className='a_inputWrap'>
            <DropDown
              labelField='modelName'
              valueField='modelName'
              options={this.props.store.PreditectedDetailList.Models}
              onChange={this.onChangeFormat}
              value={this.props.store.clonedModel.selectedModel}
            />
          </div>
        </div>
      </FormGroup>
    );
  }
}

export default PredictedModel;



// WEBPACK FOOTER //
// ./ui/share/components/controls/predictedField/Izenda.PredictedModel.js